/*global BMS*/
import React, {Component, Fragment} from "react";
import connect from "react-redux/es/connect/connect";
import style from "../css/carousel3.css";
import {VIRTUALS} from "../../../constants/games";
import {ASSETS_URL} from "../../../constants/endpoints";
import {HTML_VIDEO_IFRAME_ID, HTML_VIRTUALS_VIDEO_PLAYER_ID,} from "../../../constants/identifiers";
import {getText} from "../../../helpers/localization";
import {setGameControllerState} from "../../../actions/gamesActions";
// import Attracts from "./attracts";
import {setVideoMuted} from "../../../actions/systemActions";
import {removeNoMoreBetsEvent, setReceivedEvents, setResultCounter} from "../../../actions/eventsActions";
import QuickBetCard from "./quickBetCard";
import ResultCard from "./resultCard";
import {isPlayerStatusIgnore} from "../modules/racing/helpers/racersHelper";
import {MATCHDAY_MODULE_TYPE} from "../modules/matchday/constants/identifiers";
import {isMatchdayNMB, isMatchdayPRE, isTextBasedGame} from "../modules/matchday/helpers/matchdayHelper";
import Porthole from "porthole-proxy";
import MatchdayLiveScoreCard from "./matchdayLiveScoreCard";

const CONSTS = require('../../../constants/communications');

let previousSelectedGameIndex;
let itemsUI;
let isClickable = true;
let animationTime = 300;

const mapStateToProps = (state, ownProps) => {
    return {
        selectedGameIndex: state.vpp.selectedGameIndex, games: state.vpp.games,
        selectedMatchdaySubEventIndex: state.vpp.selectedMatchdaySubEventIndex,
        selectedEventIndex: state.vpp.selectedEventIndex,
        events: state.vpp.events,
    };
};

class Carousel extends Component {
    constructor(props) {
        super(props);
        this.isRoundStartedSent = false;
        this.lastRoundStartedSentChannel = null;
        this.hasVideoStateChange = false;

        this.videoOverlayDivRef = React.createRef();
        let store = this.props.store;
        let storeData = store.getState();

        this.state = {
            selectedGameIndex: storeData.vpp.selectedGameIndex,
            games: storeData.vpp.games,
            showVideo: true,
            webPlayerVideoStatus: undefined,
            selectedEventIndex: storeData.vpp.selectedEventIndex,
            selectedMatchdaySubEventIndex: storeData.vpp.selectedMatchdaySubEventIndex,
            events: storeData.vpp.events
        };

    }
    componentDidMount() {
        (function (that) {
            let hidden = 'hidden';
            let action;

            // Standards:
            if (hidden in document)
                document.addEventListener('visibilitychange', onchange);
            else if ((hidden = 'mozHidden') in document)
                document.addEventListener('mozvisibilitychange', onchange);
            else if ((hidden = 'webkitHidden') in document)
                document.addEventListener('webkitvisibilitychange', onchange);
            else if ((hidden = 'msHidden') in document)
                document.addEventListener('msvisibilitychange', onchange);
            // IE 9 and lower:
            else if ('onfocusin' in document)
                document.onfocusin = document.onfocusout = onchange;
            // All others:
            else
                window.onpageshow = window.onpagehide
                    = window.onfocus = window.onblur = onchange;

            function onchange(evt) {
                let v = 'visible', h = 'hidden',
                    evtMap = {
                        focus: v, focusin: v, pageshow: v, blur: h, focusout: h, pagehide: h
                    };

                evt = evt || window.event;
                if (evt.type in evtMap) {
                    action = evtMap[evt.type];
                } else {
                    action = this[hidden] ? 'hidden' : 'visible';
                }

                let showVideo = action === 'visible';
                that.setState({
                    ...that.state,
                    showVideo: showVideo
                });

            }

            // set the initial state (but only if browser supports the Page Visibility API)
            if (document[hidden] !== undefined)
                onchange({type: document[hidden] ? "blur" : "focus"});
            let windowProxy1;
            let clientBaseUrl = process.env.NODE_ENV !== 'development' && BMS && (BMS.clientBaseUrl.split("/client")[0]);
            // Create a proxy window to send to and receive message from the guest iframe
            windowProxy1 = new Porthole.WindowProxy(
                clientBaseUrl + '/inggWebViewer/proxy.html',
                'videoiframe'
            );

            //setting the webPlayerVideoStatus as STOPPED by default.
            that._updateState("STOPPED");
            windowProxy1.addEventListener((messageEvent) => {
                if (messageEvent.origin === clientBaseUrl) {
                    if (messageEvent.data['playbackEnded']) {
                         console.log(messageEvent.data);
                         that._updateState("STOPPED");
                        setTimeout(function() {  that._updateState(undefined); }, 10000);
                    }

                    if (messageEvent.data['playbackStarted']) {
                        console.log(messageEvent.data);
                        let store = that.props.store;
                        let storeData = store.getState();
                       if(storeData.vpp.games[storeData.vpp.selectedGameIndex].controllerState === CONSTS.VC2_MESSAGE_TYPE.VID
                            || (storeData.vpp.games[storeData.vpp.selectedGameIndex].controllerState !== undefined
                                    && storeData.vpp.games[storeData.vpp.selectedGameIndex].controllerState[storeData.vpp.selectedMatchdaySubEventIndex + 1] != undefined
                                    && storeData.vpp.games[storeData.vpp.selectedGameIndex].controllerState[storeData.vpp.selectedMatchdaySubEventIndex + 1] === CONSTS.VC2_MESSAGE_TYPE.VID)){
                            that._updateState("STARTED");
                        }else{
                            that._updateState("STOPPED");
                        }
                    }
                }
            });
        })(this);
    }

    componentWillUnmount() {
        clearInterval(this.interval);
    }

    componentWillReceiveProps(nextProps) {
        let store = nextProps.store;
        let storeData = store.getState();

        let showVideo = this.state.showVideo;
        if (this.state.selectedGameIndex !== storeData.vpp.selectedGameIndex) {
            showVideo = false;
            setTimeout(() => {
                this.setState({showVideo: true});
            }, animationTime);
        }

        if (nextProps && storeData) {
            this.setState({
                selectedGameIndex: storeData.vpp.selectedGameIndex,
                games: storeData.vpp.games,
                showVideo: showVideo,
                selectedMatchdaySubEventIndex: storeData.vpp.selectedMatchdaySubEventIndex,
                selectedEventIndex: storeData.vpp.selectedEventIndex,
                events: storeData.vpp.events
            });
        }
    }

    _updateState(status){
        this.hasVideoStateChange = true;
        this.setState({
            ...this.state,
            webPlayerVideoStatus: status
        });
    }

    _renderItems() {

        if (previousSelectedGameIndex === this.state.selectedGameIndex) {
            return (itemsUI);
        }


        itemsUI = VIRTUALS.map((g, index) => {

            let position;
            if (index === this.state.selectedGameIndex) {
                position = style.center;
            } else {
                if (index === this.state.selectedGameIndex - 1 || (index === (VIRTUALS.length - 1) && this.state.selectedGameIndex === 0)) {
                    position = style.left;
                } else if ((this.state.selectedGameIndex === (VIRTUALS.length - 1) && index === 0) || index === this.state.selectedGameIndex + 1) {
                    position = style.right;
                } else if (index < this.state.selectedGameIndex) {
                    position = style.left;
                } else {
                    position = style.right;
                }

                if (!(previousSelectedGameIndex !== undefined && previousSelectedGameIndex === index)) {
                    position += ' ' + style.hidden;
                }
            }

            return (<Fragment key={index}>
                <img src={`${ASSETS_URL}${VIRTUALS[index].URL.BMS_ASSETS}/backplate.png`}
                     alt={getText(VIRTUALS[index].name, this.props.store)}
                     className={`${style.iFrame} ${position}`}/>
            </Fragment>);

        });

        previousSelectedGameIndex = this.state.selectedGameIndex;

        return itemsUI;
    }

    _sendRoundStarted(channel){
        if(this.videoOverlayDivRef.current){
            this.videoOverlayDivRef.current.style.zIndex = 1;
        }
        this.isRoundStartedSent = true;
        this.lastRoundStartedSentChannel = channel;
        process.env.NODE_ENV !== 'development' && BMS.Operator.roundStarted();
    }

    _sendRoundFinished(){
        if(this.videoOverlayDivRef.current){
            this.videoOverlayDivRef.current.style.zIndex = 'auto';
        }
        this.isRoundStartedSent = false;
        this.lastRoundStartedSentChannel = null;
        process.env.NODE_ENV !== 'development' && BMS.Operator.roundFinished();
    }

    _renderVideo(attracts, isMatchday) {
        let videoUrl;
        let channelName = this.props.store.getState().vpp.games[this.props.store.getState().vpp.selectedGameIndex].channel;
        if (isMatchday)
            videoUrl = VIRTUALS[this.state.selectedGameIndex].URL.VIDEO_URL + '_' + (parseInt(this.state.selectedMatchdaySubEventIndex, 10) + 1);
        else
            videoUrl = VIRTUALS[this.state.selectedGameIndex].URL.VIDEO_URL;
        if (this.state.showVideo) {
            if (isMatchday ? !isTextBasedGame(channelName) : true) {
                return (<div id='video-iframe-container' className={style.videoIframeContainer}>
                    <iframe id={HTML_VIDEO_IFRAME_ID} name='videoiframe' src={videoUrl} frameBorder='0'
                        title={VIRTUALS[this.state.selectedGameIndex].name} className={style.videoIframe} />
                    {attracts}
                </div>)
            } else {
                return (<div id='video-iframe-container' className={style.videoIframeContainer}>
                    {attracts}
                </div>)
            }
        }
        return (undefined);
    }

    render() {
        let store = this.props.store;
        let storeData = store.getState();
        let isMatchdayChannel = storeData.vpp.games[this.state.selectedGameIndex].type == MATCHDAY_MODULE_TYPE;
        let hideAttract = false;
        let output;
        let attracts;

        //TODO; this should be removed once we receive controller status through Porthole.
        let webPlayerVideoStatus;
        let channel = storeData.vpp.events && storeData.vpp.events[0] && storeData.vpp.events[0].channel ? storeData.vpp.events[0].channel : null;
        if ((isPlayerStatusIgnore(channel) || isTextBasedGame(channel)) && this.state.webPlayerVideoStatus !== "STOPPED") {
            //TODO: Remove this logic as this is a temp fix done.
            let selectedRacingLastResult = storeData.vpp.games[this.state.selectedGameIndex].lastResult;
            if (isTextBasedGame(channel) || (selectedRacingLastResult
                && storeData.vpp.events
                && storeData.vpp.events[0]
                && storeData.vpp.events[0].channel === selectedRacingLastResult.channel
                && Number(selectedRacingLastResult.eventId) === storeData.vpp.events[0].eventId
                && storeData.vpp.games[this.state.selectedGameIndex].controllerState === CONSTS.VC2_MESSAGE_TYPE.RES)) {
                setTimeout(() => {
                    this._updateState("STOPPED");
                }, isTextBasedGame(channel) ? 0 : 9000);
            }
        }
        webPlayerVideoStatus = this.state.webPlayerVideoStatus;

        // Round started and round ended logic. FEIM
        if(this.isRoundStartedSent && isMatchdayChannel && this.state.selectedEventIndex !== 0){
            this._sendRoundFinished();
        } else if(this.isRoundStartedSent && this.lastRoundStartedSentChannel
            && this.lastRoundStartedSentChannel !== channel){
            this._sendRoundFinished();
        } else if(this.hasVideoStateChange && !this.isRoundStartedSent && webPlayerVideoStatus === "STARTED"){
            this.hasVideoStateChange = false;
            this._sendRoundStarted(channel);
        } else if(this.hasVideoStateChange && this.isRoundStartedSent && webPlayerVideoStatus === "STOPPED"){
            this.hasVideoStateChange = false;
            this._sendRoundFinished();
        }
        if ((isMatchdayChannel && isTextBasedGame(channel) && (this.state.selectedEventIndex !== 0 || isMatchdayPRE(this.state.games[this.state.selectedGameIndex])))
            || (!this.state.games[this.state.selectedGameIndex].isResultShowing
                && ((this.state.games[this.state.selectedGameIndex].controllerState === CONSTS.VC2_MESSAGE_TYPE.PRE
                        || storeData.vpp.games[this.state.selectedGameIndex].controllerState === CONSTS.VC2_MESSAGE_TYPE.NMB)
                    || (this.state.games[this.state.selectedGameIndex].controllerState != undefined
                        && this.state.games[this.state.selectedGameIndex].controllerState[1] != undefined
                        && (this.state.games[this.state.selectedGameIndex].controllerState[1] === CONSTS.VC2_MESSAGE_TYPE.PRE || isMatchdayNMB(storeData)))))) {
            // attracts = (<Attracts store={this.props.store}/>);
            if (isMatchdayChannel && !isMatchdayNMB(storeData) && this.state.games[this.state.selectedGameIndex].controllerState !== undefined
                && this.state.games[this.state.selectedGameIndex].controllerState[1] === CONSTS.VC2_MESSAGE_TYPE.PRE
                && !isTextBasedGame(channel)) {
                hideAttract = true;
            } else {
                attracts = (<QuickBetCard store={this.props.store}/>);
            }
        } else if ((!isMatchdayChannel && this.state.games[this.state.selectedGameIndex].isResultShowing)
            || (isMatchdayChannel && this.state.games[this.state.selectedGameIndex].isResultShowing && this.state.selectedEventIndex === 0)
            || ((storeData.vpp.games[this.state.selectedGameIndex].controllerState === CONSTS.VC2_MESSAGE_TYPE.RES
                || (this.state.selectedEventIndex === 0
                    && this.state.games[this.state.selectedGameIndex].controllerState !== undefined
                    && this.state.games[this.state.selectedGameIndex].controllerState[this.state.selectedMatchdaySubEventIndex + 1] != undefined
                    && this.state.games[this.state.selectedGameIndex].controllerState[this.state.selectedMatchdaySubEventIndex + 1] === CONSTS.VC2_MESSAGE_TYPE.RES))
                && (storeData.vpp.games[this.state.selectedGameIndex].isResulted || webPlayerVideoStatus === "STOPPED"))) {
            if (storeData.vpp.games[this.state.selectedGameIndex].isResultCountDownStart === true) {
                let gameIndex = this.state.selectedGameIndex;
                if (isMatchdayChannel) {
                    setTimeout(() => {
                        store.dispatch(setResultCounter(storeData.vpp.games[gameIndex].channel, false, true));
                    }, 7000);
                } else {
                    store.dispatch(setResultCounter(storeData.vpp.games[gameIndex].channel, false, true));
                }
                setTimeout(function () {
                    this.props.store.dispatch(setResultCounter(this.props.store.getState().vpp.games[gameIndex].channel, false, false));
                    if (isMatchdayChannel) {
                        this.props.store.dispatch(setGameControllerState(this.props.store.getState().vpp.games[gameIndex].channel, CONSTS.VC2_MESSAGE_TYPE.PRE, true, true))
                    } else {
                        this.props.store.dispatch(setGameControllerState(this.props.store.getState().vpp.games[gameIndex].channel, CONSTS.VC2_MESSAGE_TYPE.PRE));
                    }
                    this.props.store.dispatch(setReceivedEvents([], true, this.props.store.getState().vpp.games[gameIndex].channel));
                    this.props.store.dispatch(removeNoMoreBetsEvent(this.props.store.getState().vpp.games[gameIndex].channel));
                }.bind(this), isMatchdayChannel ? 17000 : 10000);
            } else if (storeData.vpp.games[this.state.selectedGameIndex].isResultCountDownStart === undefined) {
                if (isMatchdayChannel) {
                    this.props.store.dispatch(setGameControllerState(storeData.vpp.games[this.state.selectedGameIndex].channel, CONSTS.VC2_MESSAGE_TYPE.PRE, true, true))
                } else {
                    this.props.store.dispatch(setGameControllerState(storeData.vpp.games[this.state.selectedGameIndex].channel, CONSTS.VC2_MESSAGE_TYPE.PRE));
                }
                store.dispatch(setReceivedEvents([], true, storeData.vpp.games[this.state.selectedGameIndex].channel));
                store.dispatch(removeNoMoreBetsEvent(storeData.vpp.games[this.state.selectedGameIndex].channel));
            }
            if (storeData.vpp.games[this.state.selectedGameIndex].isResultCountDownStart !== undefined && (webPlayerVideoStatus === undefined || webPlayerVideoStatus === "STOPPED")) {
                attracts = (<ResultCard store={this.props.store}/>);
            }
            //END Remove this logic as this is a temp fix done for result screen issues. PROD_VSB-2238. This needs to be removed in 2.1.0
        } else {
            attracts = '';
            if (isMatchdayChannel) {
                if (this.state.selectedEventIndex === 0) {
                    hideAttract = false;
                    if (isTextBasedGame(channel)) {
                        attracts = (<MatchdayLiveScoreCard store={this.props.store}/>);
                    }
                } else
                     hideAttract = true;
            }
        }
        if (hideAttract) {
            output = attracts;
        } else {
            output = (<div
                className={`${style.iFrameAnimationContainer} ${storeData.vpp.isInFullViewPlayer ? style.fullViewPlayer : ''}`}>
                {this._renderItems()}
                <div ref={this.videoOverlayDivRef} className={style.videoOverlay} onClick={(event) => {
                    this._videoOverlayDetectClick(event)
                }}/>
                {this._renderVideo(attracts, isMatchdayChannel)}
            </div>);
        }
        return (<div className={style.carouselMainContainer}>{output}</div>);
    }

    _videoOverlayDetectClick(e) {
        let parentPosition = e.currentTarget.getBoundingClientRect();
        let xPosition = e.clientX - parentPosition.left;
        let yPosition = e.clientY - parentPosition.top;

        try {
            let iFrameDocument = document.getElementById('video-iframe').contentWindow.document;
            iFrameDocument.elementFromPoint(xPosition, yPosition).click();

            let webPlayer = iFrameDocument.getElementById(HTML_VIRTUALS_VIDEO_PLAYER_ID);
            BMS.Operator.updateGameSound(!webPlayer.muted);
            this.props.store.dispatch(setVideoMuted(webPlayer.muted));
        } catch (err) {
            console.error('Blocked click from accessing a cross-origin frame');
        }

    }

}

export default connect(mapStateToProps)(Carousel);



// WEBPACK FOOTER //
// ./src/ui-modules/sports-book/components/carousel3.js